import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Gate component for routes that require login. If the auth check is still pending,
 * shows a minimal placeholder; if anonymous, redirects to /login preserving the
 * intended destination so we can bounce back after a successful sign-in.
 */
export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // Auth check in flight — render nothing yet so the page doesn't flash anonymous.
    return <div style={{ padding: 40, color: '#888' }}>Loading…</div>;
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
